<template>
  <div ref="exportMe">
    <el-row class="jobseeker-cv border-gradient border-gradient-blue">
      <el-col>
        <el-row type="flex">
          <el-col v-if="ShowProfile" style="width:40%">
            <span
              v-if="
                Image !== null &&
                  Image !== undefined &&
                  Image.toString() !== 'na' &&
                  Image.toString() !== ''
              "
            >
              <img :src="Image" class="image-rounded-large" />
            </span>
            <span v-else class="initials-extra-large"
              >{{
                getFirstLetter(UserInfo.fullName.split(" ")[0].toUpperCase()) +
                  " " +
                  getFirstLetter(UserInfo.fullName.split(" ")[1].toUpperCase())
              }}
            </span>
          </el-col>
          <el-col
            v-bind:style="ShowProfile ? { width: '60%' } : { width: '100%' }"
          >
            <el-row :style="getRowStyle()" v-if="this.$props.UserInfo">
              <el-col style="text-align:center">
                <span class="cv-name">{{
                  this.$props.UserInfo.fullName.split(" ")[0].toUpperCase()
                }}</span>
              </el-col>
            </el-row>
            <el-row :style="getRowStyle()" v-if="this.$props.UserInfo">
              <el-col style="text-align:center">
                <span class="cv-name">{{
                  this.$props.UserInfo.fullName.split(" ")[1].toUpperCase()
                }}</span>
              </el-col>
            </el-row>
            <el-row style="margin-top:20px" v-if="Data && Data.sgaEmployeeInfo">
              <el-col style="text-align:center">
                <span
                  class="role-title"
                  v-if="
                    profile.configuration.profileConfiguration
                      .personalInformation.seekingRole &&
                      profile.configuration.profileConfiguration
                        .personalInformation.seekingRoleValue != 'N/A'
                  "
                  >{{
                    profile.configuration.profileConfiguration
                      .personalInformation.seekingRoleValue
                  }}</span
                >
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="margin-top:40px" type="flex">
          <el-col style="width:40%;padding-right:20px" :xl="6" :lg="6" :md="6">
            <el-row
              :style="getInfoRowStyle()"
              type="flex"
              v-if="
                profile.configuration.profileConfiguration.personalInformation
                  .address
              "
            >
              <el-col style="width:33%" :xl="5" :lg="5" :md="5">
                <span class="cv-info-label">ZIP CODE:</span>
              </el-col>
              <el-col style="width:67%" :xl="10" :lg="10" :md="10">
                <span class="cv-info ob">{{
                  profile.configuration.profileConfiguration.personalInformation
                    .addressValue
                }}</span>
              </el-col>
            </el-row>

            <el-row
              :style="getInfoRowStyle()"
              type="flex"
              v-if="
                profile.configuration.profileConfiguration.personalInformation
                  .phone
              "
            >
              <el-col style="width:33%" :xl="10" :lg="10" :md="10">
                <span class="cv-info-label">PHONE:</span>
              </el-col>
              <el-col style="width:67%" :xl="10" :lg="10" :md="10">
                <span class="cv-info">{{
                  profile.configuration.profileConfiguration.personalInformation
                    .phoneValue
                }}</span>
              </el-col>
            </el-row>
            <el-row
              :style="getInfoRowStyle()"
              type="flex"
              v-if="
                profile.configuration.profileConfiguration.personalInformation
                  .email
              "
            >
              <el-col style="width:33%" :xl="10" :lg="10" :md="10">
                <span class="cv-info-label">EMAIL:</span>
              </el-col>
              <el-col style="width:67%" :xl="10" :lg="10" :md="10">
                <span class="cv-info email-ow">{{
                  profile.configuration.profileConfiguration.personalInformation
                    .emailValue
                }}</span>
              </el-col>
            </el-row>
            <el-row
              style="margin-top:25px"
              v-if="
                profile.configuration.profileConfiguration.personalInformation
                  .education != null &&
                  profile.configuration.profileConfiguration.personalInformation
                    .education != undefined
              "
            >
              <el-col>
                <el-row :style="getInfoRowStyle()">
                  <el-col>
                    <span class="cv-section-header">EDUCATION</span>
                  </el-col>
                </el-row>
                <div
                  v-if="
                    profile.configuration.profileConfiguration
                      .personalInformation.education.fourthLevel
                  "
                >
                  <div
                    :style="getInfoRowStyle()"
                    v-if="
                      profile.configuration.profileConfiguration
                        .personalInformation.education.fourthLevelValue
                        .doctoralDegreeDetails != null &&
                        profile.configuration.profileConfiguration
                          .personalInformation.education.fourthLevelValue
                          .doctoralDegreeDetails.length > 0
                    "
                  >
                    <el-row>
                      <el-col>
                        <span class="cv-info-label">DOCTORAL DEGREE</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <el-row
                          v-for="(course, index) in profile.configuration
                            .profileConfiguration.personalInformation.education
                            .fourthLevelValue.doctoralDegreeDetails"
                          :key="index"
                        >
                          <el-col>
                            <span class="cv-info">{{
                              course.courseTitle
                            }}</span>
                            <span
                              class="cv-info"
                              style="word-break: break-word;"
                              v-if="course.currentlyAttending"
                            >
                              - Graduation Date is
                              {{
                                course.graduationDate | moment("MMMM DD, YYYY")
                              }}
                            </span>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </div>
                  <div
                    :style="getInfoRowStyle()"
                    v-if="
                      profile.configuration.profileConfiguration
                        .personalInformation.education.fourthLevelValue
                        .mastersDegreeDetails != null &&
                        profile.configuration.profileConfiguration
                          .personalInformation.education.fourthLevelValue
                          .mastersDegreeDetails.length > 0
                    "
                  >
                    <el-row>
                      <el-col>
                        <span class="cv-info-label">MASTER'S DEGREE</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <el-row
                          v-for="(course, index) in profile.configuration
                            .profileConfiguration.personalInformation.education
                            .fourthLevelValue.mastersDegreeDetails"
                          :key="index"
                        >
                          <el-col>
                            <span class="cv-info">{{
                              course.courseTitle
                            }}</span>
                            <span
                              class="cv-info"
                              style="word-break: break-word;"
                              v-if="course.currentlyAttending"
                            >
                              - Graduation Date is
                              {{
                                course.graduationDate | moment("MMMM DD, YYYY")
                              }}
                            </span>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div
                  v-if="
                    profile.configuration.profileConfiguration
                      .personalInformation.education.thirdLevel
                  "
                >
                  <div
                    :style="getInfoRowStyle()"
                    v-if="
                      profile.configuration.profileConfiguration
                        .personalInformation.education.thirdLevelValue
                        .bachelorsDegreeDetails != null &&
                        profile.configuration.profileConfiguration
                          .personalInformation.education.thirdLevelValue
                          .bachelorsDegreeDetails.length > 0
                    "
                  >
                    <el-row>
                      <el-col>
                        <span class="cv-info-label">BACHELOR'S DEGREE</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <el-row
                          v-for="(course, index) in profile.configuration
                            .profileConfiguration.personalInformation.education
                            .thirdLevelValue.bachelorsDegreeDetails"
                          :key="index"
                        >
                          <el-col>
                            <span class="cv-info">{{
                              course.courseTitle
                            }}</span>
                            <span
                              class="cv-info"
                              style="word-break: break-word;"
                              v-if="course.currentlyAttending"
                            >
                              - Graduation Date is
                              {{
                                course.graduationDate | moment("MMMM DD, YYYY")
                              }}
                            </span>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </div>
                  <div
                    :style="getInfoRowStyle()"
                    v-if="
                      profile.configuration.profileConfiguration
                        .personalInformation.education.thirdLevelValue
                        .associateDegreeDetails != null &&
                        profile.configuration.profileConfiguration
                          .personalInformation.education.thirdLevelValue
                          .associateDegreeDetails.length > 0
                    "
                  >
                    <el-row>
                      <el-col>
                        <span class="cv-info-label">ASSOCIATE DEGREE</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <el-row
                          v-for="(course, index) in profile.configuration
                            .profileConfiguration.personalInformation.education
                            .thirdLevelValue.associateDegreeDetails"
                          :key="index"
                        >
                          <el-col>
                            <span class="cv-info">{{
                              course.courseTitle
                            }}</span>
                            <span
                              class="cv-info"
                              style="word-break: break-word;"
                              v-if="course.currentlyAttending"
                            >
                              - Graduation Date is
                              {{
                                course.graduationDate | moment("MMMM DD, YYYY")
                              }}
                            </span>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div
                  v-if="
                    profile.configuration.profileConfiguration
                      .personalInformation.education.secondaryLevel
                  "
                >
                  <div
                    :style="getInfoRowStyle()"
                    v-if="
                      profile.configuration.profileConfiguration
                        .personalInformation.education.secondaryLevelValue
                        .aLevelDetailsValue != null &&
                        profile.configuration.profileConfiguration
                          .personalInformation.education.secondaryLevelValue
                          .aLevelDetailsValue.length > 0
                    "
                  >
                    <el-row>
                      <el-col>
                        <span class="cv-info-label">A LEVELS</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <el-row
                          v-for="(course, index) in profile.configuration
                            .profileConfiguration.personalInformation.education
                            .secondaryLevelValue.aLevelDetailsValue"
                          :key="index"
                        >
                          <el-col>
                            <span class="cv-info"
                              >{{ course.subject }} ({{ course.grade }})</span
                            >
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </div>
                  <div
                    :style="getInfoRowStyle()"
                    v-if="
                      profile.configuration.profileConfiguration
                        .personalInformation.education.secondaryLevelValue
                        .oLevelDetailsValue != null &&
                        profile.configuration.profileConfiguration
                          .personalInformation.education.secondaryLevelValue
                          .oLevelDetailsValue.length > 0
                    "
                  >
                    <el-row>
                      <el-col>
                        <span class="cv-info-label">O LEVELS DEGREE</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <el-row
                          v-for="(course, index) in profile.configuration
                            .profileConfiguration.personalInformation.education
                            .secondaryLevelValue.oLevelDetailsValue"
                          :key="index"
                        >
                          <el-col>
                            <span class="cv-info"
                              >{{ course.subject }} ({{ course.grade }})</span
                            >
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </div>
                  <div
                    :style="getInfoRowStyle()"
                    v-if="
                      profile.configuration.profileConfiguration
                        .personalInformation.education.secondaryLevelValue
                        .leavingCertValue != 'n/a'
                    "
                  >
                    <el-row>
                      <el-col>
                        <span class="cv-info-label">{{
                          profile.configuration.profileConfiguration
                            .personalInformation.education.secondaryLevelValue
                            .leavingCertValue
                        }}</span>
                      </el-col>
                    </el-row>
                  </div>
                  <div
                    :style="getInfoRowStyle()"
                    v-if="
                      profile.configuration.profileConfiguration
                        .personalInformation.education.secondaryLevelValue
                        .gedValue != 'n/a'
                    "
                  >
                    <el-row>
                      <el-col>
                        <span class="cv-info-label">{{
                          profile.configuration.profileConfiguration
                            .personalInformation.education.secondaryLevelValue
                            .gedValue
                        }}</span>
                        <span
                          class="cv-info"
                          style="word-break: break-word;"
                          v-if="
                            profile.configuration.profileConfiguration
                              .personalInformation.education.secondaryLevelValue
                              .gedAttending
                          "
                        >
                          <br />
                          Graduation Date is
                          {{
                            profile.configuration.profileConfiguration
                              .personalInformation.education.secondaryLevelValue
                              .gedGraduationDate | moment("MMMM DD, YYYY")
                          }}
                        </span>
                      </el-col>
                    </el-row>
                  </div>
                  <div
                    :style="getInfoRowStyle()"
                    v-if="
                      profile.configuration.profileConfiguration
                        .personalInformation.education.secondaryLevelValue
                        .highSchoolDiplomaValue != 'n/a'
                    "
                  >
                    <el-row>
                      <el-col>
                        <span class="cv-info-label">{{
                          profile.configuration.profileConfiguration
                            .personalInformation.education.secondaryLevelValue
                            .highSchoolDiplomaValue
                        }}</span>
                        <br />
                        <span
                          class="cv-info"
                          style="word-break: break-word;"
                          v-if="
                            profile.configuration.profileConfiguration
                              .personalInformation.education.secondaryLevelValue
                              .highSchoolDiplomaAttending
                          "
                        >
                          Graduation Date is
                          {{
                            profile.configuration.profileConfiguration
                              .personalInformation.education.secondaryLevelValue
                              .highSchoolDiplomaGraduationDate
                              | moment("MMMM DD, YYYY")
                          }}
                        </span>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row
              style="margin-top:25px"
              v-if="Data.culture != null && Data.culture != undefined"
            >
              <el-col>
                <el-row :style="getInfoRowStyle()">
                  <el-col>
                    <span class="cv-section-header">IDEAL COMPANY CULTURE</span>
                  </el-col>
                </el-row>
                <el-row
                  v-for="(option, index) in Data.culture.selectedCultureOptions"
                  :key="index"
                >
                  <el-col>
                    <span class="cv-info">- {{ option }}</span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row
              style="margin-top:25px"
              v-if="
                profile.configuration.profileConfiguration.personalInformation
                  .certifications
              "
            >
              <el-col
                v-if="
                  profile.configuration.profileConfiguration.personalInformation
                    .certificationsValue.userCertifications != null &&
                    profile.configuration.profileConfiguration
                      .personalInformation.certificationsValue
                      .userCertifications.length > 0
                "
              >
                <el-row :style="getInfoRowStyle()">
                  <el-col>
                    <span class="cv-section-header">CERTIFICATIONS</span>
                  </el-col>
                </el-row>
                <el-row
                  style="margin-bottom:10px"
                  v-for="(cert, index) in profile.configuration
                    .profileConfiguration.personalInformation
                    .certificationsValue.userCertifications"
                  :key="index"
                >
                  <el-col>
                    <el-row>
                      <el-col>
                        <!-- <span class="cv-info" style="color:#505050 !important">{{ getCertificateDescription(cert.CodeDeTailId) }}</span> -->
                        <span
                          class="cv-info"
                          style="color:#505050 !important"
                          >{{ cert.codeDetailDesc }}</span
                        >
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <span
                          class="cv-info"
                          v-if="cert.acquiredDt != '0001-01-01T00:00:00Z'"
                          >Date Acquired:
                          {{ cert.acquiredDt | moment("MMMM DD, YYYY") }}</span
                        >
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <span
                          class="cv-info"
                          v-if="
                            cert.noExpiration == false &&
                              cert.expirationDt != '0001-01-01T00:00:00Z'
                          "
                          >Expiration Date:
                          {{
                            cert.expirationDt | moment("MMMM DD, YYYY")
                          }}</span
                        >
                        <span
                          class="cv-info"
                          v-else-if="
                            cert.noExpiration == false &&
                              cert.expirationDt == '0001-01-01T00:00:00Z'
                          "
                          >Expiration Date: - N/A</span
                        >
                        <span class="cv-info" v-else
                          >Expiration Date: No Expiration</span
                        >
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
          <el-col
            style="width:60%;padding-left:30px"
            class="cv-divider border-gradient-blue"
            :xl="15"
            :lg="15"
            :md="15"
          >
            <div
              v-if="
                this.profile.configuration.profileConfiguration
                  .coreStrengthInformation.workHistory
              "
            >
              <el-row :style="getInfoRowStyle()">
                <el-col>
                  <span class="cv-section-header">Work History</span>
                </el-col>
              </el-row>
              <el-row
                style="margin-bottom:10px"
                v-for="(work, index) in profile.configuration
                  .profileConfiguration.coreStrengthInformation.workHistoryValue
                  .userWorkHistory"
                :key="index"
              >
                <el-col>
                  <span
                    class="cv-info"
                    v-if="work.jobTitleVisible"
                    style="color:#505050 !important"
                    >{{ work.jobTitle }}</span
                  ><br v-if="work.jobTitleVisible" />
                  <span
                    class="cv-info"
                    v-if="
                      work.workedFrom != '0001-01-01T00:00:00Z' &&
                        work.workedFromVisible
                    "
                    >Start Date:
                    {{ work.workedFrom | moment("MMMM DD, YYYY") }}</span
                  ><br
                    v-if="
                      work.workedFrom != '0001-01-01T00:00:00Z' &&
                        work.workedFromVisible
                    "
                  />

                  <span
                    class="cv-info"
                    v-if="
                      work.workedToPresent == true &&
                        work.workedToVisible &&
                        (work.workedTo == '0001-01-01T00:00:00Z' ||
                          work.workedTo == null)
                    "
                    >End Date: Present Date <br v-if="work.workedToVisible"
                  /></span>
                  <span
                    class="cv-info"
                    v-if="
                      work.workedToPresent != true &&
                        work.workedToVisible &&
                        (work.workedTo == '0001-01-01T00:00:00Z' ||
                          work.workedTo == null)
                    "
                    >End Date: N/A <br v-if="work.workedToVisible"
                  /></span>
                  <span
                    class="cv-info"
                    v-if="
                      work.workedToPresent != true &&
                        work.workedToVisible &&
                        work.workedTo != '0001-01-01T00:00:00Z' &&
                        work.workedTo != null
                    "
                    >End Date: {{ work.workedTo | moment("MMMM DD, YYYY") }}
                    <br v-if="work.workedToVisible"
                  /></span>

                  <span class="cv-info" v-if="work.employerVisible">{{
                    work.employer
                  }}</span
                  ><br v-if="work.employerVisible" />
                  <span class="cv-info" v-if="work.employerAddressVisible">{{
                    work.employerAddress
                  }}</span
                  ><br v-if="work.employerAddressVisible" />
                  <span class="cv-info" v-if="work.employerNumberVisible"
                    >{{ work.selectedCountryCode }}
                    {{ work.employerNumber }}</span
                  ><br v-if="work.employerNumberVisible" />
                </el-col>
              </el-row>
            </div>
            <div
              v-if="
                this.profile.configuration.profileConfiguration
                  .coreStrengthInformation.taskDuties
              "
            >
              <el-row :style="getInfoRowStyle()">
                <el-col>
                  <span class="cv-section-header">TASKS/DUTIES</span>
                </el-col>
              </el-row>
              <!-- <el-row v-for="(task, index) in Data.SgaYourJob.JobDescriptionTasks" :key="index">
                <el-col>
                  <span class="cv-info">- {{ task }}</span>
                </el-col>
              </el-row> -->
              <el-row v-for="(code, index1) in currentRoleCodes" :key="index1">
                <el-col>
                  <span
                    :id="'task_id_' + code"
                    class="cv-info-label"
                    v-if="selectedRoleTitle(code) != ''"
                    >{{ selectedRoleTitle(code) }}</span
                  >
                  <div
                    v-for="(task, index) in $props.profile.configuration
                      .profileConfiguration.coreStrengthInformation
                      .taskDutiesValue.jobDescriptionTasks"
                    :key="index"
                  >
                    <div v-if="task.indexOf('`') > -1">
                      <div v-if="task.split('`')[1] == code">
                        <span class="cv-info">- {{ task.split("`")[0] }}</span>
                      </div>
                    </div>
                    <div v-if="code == 'Others'">
                      <div v-if="task.indexOf('`') == -1">
                        <span class="cv-info class_Others">- {{ task }}</span>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div
              style="margin-top:25px"
              v-if="
                this.profile.configuration.profileConfiguration
                  .coreStrengthInformation.activities
              "
            >
              <el-row :style="getInfoRowStyle()">
                <el-col>
                  <span class="cv-section-header">ACTIVITIES</span>
                </el-col>
              </el-row>
              <el-row
                v-for="(activity, index) in this.profile.configuration
                  .profileConfiguration.coreStrengthInformation.activitiesValue
                  .workingPracticeActivities"
                :key="index"
              >
                <el-col>
                  <span class="cv-info">- {{ activity.selection }}</span>
                </el-col>
              </el-row>
            </div>
            <div
              style="margin-top:25px"
              v-if="
                this.profile.configuration.profileConfiguration
                  .personalInformation.education.sectorExperience
              "
            >
              <el-row :style="getInfoRowStyle()">
                <el-col>
                  <span class="cv-section-header">SECTOR EXPERIENCES</span>
                </el-col>
              </el-row>
              <el-row
                style="margin-bottom:10px;"
                v-for="(experience, index) in this.profile.configuration
                  .profileConfiguration.personalInformation.education
                  .sectorExperienceValue.experienceDetails"
                :key="index"
              >
                <el-col>
                  <el-row>
                    <el-col>
                      <span class="cv-info-label">{{
                        experience.title.toUpperCase()
                      }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <span class="cv-info">{{ experience.years }}</span>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
            <div
              style="margin-top:25px"
              v-if="
                this.profile.configuration.profileConfiguration
                  .coreStrengthInformation.knowledge
              "
            >
              <el-row :style="getInfoRowStyle()">
                <el-col>
                  <span class="cv-section-header">KNOWLEDGE</span>
                </el-col>
              </el-row>
              <el-row
                style="margin-bottom:10px;"
                v-for="(knowledge, index) in this.profile.configuration
                  .profileConfiguration.coreStrengthInformation.knowledgeValue
                  .knowledgeRegularlyUsed"
                :key="index"
              >
                <el-col>
                  <el-row>
                    <el-col>
                      <span class="cv-info-label">{{
                        knowledge.selection.toUpperCase()
                      }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <span class="cv-info">{{
                        knowledge.yearsOfExperience
                      }}</span>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
            <div
              style="margin-top:25px"
              v-if="
                this.profile.configuration.profileConfiguration
                  .coreStrengthInformation.essentialSkills
              "
            >
              <el-row :style="getInfoRowStyle()">
                <el-col>
                  <span class="cv-section-header">ESSENTIAL SKILLS</span>
                </el-col>
              </el-row>
              <el-row
                v-for="(mindset, index) in this.profile.configuration
                  .profileConfiguration.coreStrengthInformation
                  .essentialSkillsValue.mindsets"
                :key="index"
              >
                <el-col>
                  <span class="cv-info">- {{ mindset.selection }}</span>
                </el-col>
              </el-row>
            </div>
            <div
              style="margin-top:25px"
              v-if="
                this.profile.configuration.profileConfiguration
                  .coreStrengthInformation.skills
              "
            >
              <el-row :style="getInfoRowStyle()">
                <el-col>
                  <span class="cv-section-header">SKILLS</span>
                </el-col>
              </el-row>
              <el-row
                v-for="(skill, index) in this.profile.configuration
                  .profileConfiguration.coreStrengthInformation.skillsValue
                  .workingPracticeSkills"
                :key="index"
              >
                <el-col>
                  <el-row>
                    <el-col>
                      <span class="cv-info-label">{{ skill.selection }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <span class="cv-info">{{ skill.yearsOfExperience }}</span>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
            <div
              style="margin-top:25px"
              v-if="
                this.profile.configuration.profileConfiguration
                  .coreStrengthInformation.hiddenTalents
              "
            >
              <el-row :style="getInfoRowStyle()">
                <el-col>
                  <span class="cv-section-header">HIDDEN TALENTS</span>
                </el-col>
              </el-row>
              <el-row
                v-for="(hiddenTalent, index) in this.profile.configuration
                  .profileConfiguration.coreStrengthInformation
                  .hiddenTalentsValue.skillsKnowledgeOutsideWork"
                :key="index"
              >
                <el-col>
                  <span class="cv-info">- {{ hiddenTalent }}</span>
                </el-col>
              </el-row>
            </div>
            <div
                style="margin-top: 25px"
                  v-if="this.profile.configuration.profileConfiguration
                      .coreStrengthInformation.technologies &&
                    this.profile.configuration.profileConfiguration
                      .coreStrengthInformation.technologiesValue.userTechnologies"
                >
                <el-row :style="getInfoRowStyle()">
                    <el-col>
                      <span class="cv-section-header">TECHNOLOGIES</span>
                    </el-col>
                  </el-row>
                <el-row v-for="technology in this.profile.configuration.profileConfiguration
                  .coreStrengthInformation.technologiesValue.userTechnologies" :key="technology.selection">
                  <el-col>
                    <el-row>
                      <el-col>
                        <span class="cv-info-label">{{ technology.selection }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <span class="cv-info">{{ technology.yearsOfExperience }}</span>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div
      class="jobseeker-cv-copyright"
      style="text-align:center;margin-top:5px;"
    >
      <span style="color:gray; font-size: 14px;"
        >This resume has been generated using talentsensus.com © {{ appYear }}
        TalentSensus Inc. All Rights Reserved</span
      >
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import dataDelimiter from "@/utils/data.utils";
import { jsPDF } from "jspdf";

export default {
  name: "JobSeekerCV",
  props: {
    Data: {
      type: Object
      // default: {}
    },
    profile: {
      type: Object
      // default: {}
    },
    Image: {
      type: String,
      default: ""
    },
    UserInfo: {
      type: Object
      // default: {}
    },
    ShowProfile: {
      type: Boolean
    }
  },
  created() {
    this.$store.dispatch("sga/getPublicCodeHeaderDetails");
  },
  data() {
    return {
      ShowProfilePic: false
    };
  },
  computed: {
    currentSga() {
      return this.$store.state.sga.current_sga;
    },
    selectedRoleCode() {
      return this.Data.sgaEmployeeInfo.employeeRoleONETCode.split(",") || [];
    },
    selectedRoleDesc() {
      const roleTitle = this.Data.sgaEmployeeInfo.employeeRoleTitle || "";
      return roleTitle.split(dataDelimiter) || [];
    },
    certificates() {
      return this.$store.state.sga.certificates;
    },
    currentRoleCodes() {
      if (this.Data.sgaEmployeeInfo.employeeRoleONETCode == null) return null;
      var rolecode = this.Data.sgaEmployeeInfo.employeeRoleONETCode.split(", ");
      rolecode.push("Others");
      return rolecode;
    },
    currentRoleTitle() {
      if (this.Data.sgaEmployeeInfo.employeeRoleONETCode == null) return null;

      const roleTitle = this.Data.sgaEmployeeInfo.employeeRoleTitle || "";
      var roleTitles = roleTitle.split(dataDelimiter);
      roleTitles.push("Others");
      
      return roleTitles;
    },
    retainOthersLabel() {
      if (
        !this.$store.state.sga.current_sga.sgaEmployeeInfo.employeeRoleONETCode
      )
        return null;
      var retainOthersLabel = false;
      this.Data.sgaYourJob.jobDescriptionTasks.forEach(element => {
        if (element.indexOf("`") > -1) retainOthersLabel = true;
      });

      return retainOthersLabel;
    },
    appYear() {
      return process.env.VUE_APP_YEAR;
    },
  },
  methods: {
    selectedRoleTitle(code) {
      if (code == "Others") return "Others";
      var roles = this.Data.sgaEmployeeInfo.employeeRoleTitleCodeSequence.split(
        ","
      );
      var roleFormatted = "";
      var ctr = 0;
      roles.forEach(element => {
        if (element.trim() == code.trim()) {
          roleFormatted += this.selectedRoleDesc[ctr] + "/";
        }
        ctr++;
      });

      roleFormatted = roleFormatted.substring(0, roleFormatted.length - 1);
      return roleFormatted;
    },
    async export() {
      const el = this.$refs.exportMe;
      const options = {
        type: "dataURL"
      };

      let output = await this.$html2canvas(el, options);
      let doc = new jsPDF("p", "mm", [297, 210]);
      doc.addImage(output, "PNG", 0, 0);
      doc.save("CV.pdf");

      this.$emit("export-complete");
    },
    hideCV() {
      const element = document.getElementsByClassName("jobseeker-cv");
      if (element && element[0]) {
        element[0].style.display = "none";
      }
    },
    showCV(showProfile) {
      const element = document.getElementsByClassName("jobseeker-cv");
      if (element && element[0]) {
        element[0].style.display = "block";
      }

      if ($(".class_Others").length != 0) {
        var label_other = document.getElementById("task_id_Others");
        label_other.style.display = "block";
      }
    },
    getSkillsPercentage(skill) {
      switch (skill.YearsOfExperience) {
        case "Less than one year":
          return 20;
          break;
        case "1-2 years":
          return 40;
          break;
        case "3-5 years":
          return 60;
          break;
        case "5-10 years":
          return 80;
          break;
        case "10+ years":
          return 100;
          break;
      }
    },
    getRowStyle() {
      return "margin-bottom: 0;";
    },
    getInfoRowStyle() {
      return "margin-bottom: 15px";
    },
    getCertificateDescription(id) {
      return this.certificates.find(c => c.id == id).description;
    },
    getFirstLetter(name) {
      return name && name.length > 0 ? name.charAt(0) : "";
    }
  }
};
</script>

<style scoped>
#task_id_Others {
  display: none;
}
</style>
